export class ClassRoomRequest {
    public ID: number;
    public HashCode: string;
    public Class_HashCode: string;
    public NoOfClassRoom: number;
    public ClassroomName: string;
    public ClassroomSize: string;
    public YearID: number;
    public ClassroomDetail: Array<any> = [];
}